"use strict";
import { useMemo } from "react";
import { getDexTokenList } from "constants/topazTokenList";
import { getTokenLogoUrl } from "constants/tokenLogos";
import { useTokenLists } from "contexts/TokenListsContext";
import { ProtectionResult } from "data/graphql/uniswap-data-api/__generated__/types-and-hooks";
import { UniverseChainId } from "features/chains/types";
import { TokenList } from "features/dataApi/types";
import { buildCurrencyInfo } from "features/dataApi/utils";
import { currencyId } from "utils/uniswapCurrencyId";
export function useTrendingTokensCurrencyInfos(chainFilter, skip) {
  const { getTokenListTokens } = useTokenLists();
  const formattedTokens = useMemo(() => {
    if (skip) return void 0;
    const targetChainId = chainFilter || UniverseChainId.Mainnet;
    const hardcodedTokens = getDexTokenList(targetChainId);
    const seenAddresses = /* @__PURE__ */ new Set();
    const results = [];
    for (const token of hardcodedTokens) {
      seenAddresses.add(token.address.toLowerCase());
      const info = buildCurrencyInfo({
        currency: token,
        currencyId: currencyId(token),
        logoUrl: getTokenLogoUrl(token.address),
        safetyInfo: {
          tokenList: TokenList.Default,
          protectionResult: ProtectionResult.Benign
        }
      });
      if (info) {
        results.push(info);
      }
    }
    const listTokens = getTokenListTokens(targetChainId);
    for (const { token, logoURI } of listTokens) {
      if (seenAddresses.has(token.address.toLowerCase())) {
        continue;
      }
      seenAddresses.add(token.address.toLowerCase());
      const info = buildCurrencyInfo({
        currency: token,
        currencyId: currencyId(token),
        logoUrl: logoURI,
        safetyInfo: {
          tokenList: TokenList.NonDefault,
          protectionResult: ProtectionResult.Unknown
        }
      });
      if (info) {
        results.push(info);
      }
    }
    return results;
  }, [chainFilter, skip, getTokenListTokens]);
  const refetch = () => {
  };
  return {
    data: formattedTokens,
    loading: false,
    error: void 0,
    refetch
  };
}
